/**
 * SIAM TRUTH AUDIT — Brand tokens
 *
 * Single source of truth for brand colors. Imported by:
 *   - apps/web/tailwind.config.ts (color tokens)
 *   - apps/web/src/components/Logo.tsx (inline SVG fills)
 *   - apps/api (only if rendering branded emails / PDF exports)
 *
 * Do NOT hardcode #B0413E anywhere else — always import from here.
 */
export const BRAND = {
  name: 'SIAM TRUTH AUDIT',
  shortName: 'SIAM TRUTH',
  legalName: 'SIAM TRUTH AUDIT COMPANY LIMITED',
  tagline: 'Audit · Truth · Balance',
  colors: {
    /** Primary brand red — yin-yang motif, primary actions */
    red: '#B0413E',
    /** Charcoal — primary text, yin-yang dark half */
    charcoal: '#2D2D2D',
    /** Accent blue — links, info states, secondary actions */
    blue: '#1E5FA8',
    /** Surface white */
    white: '#FFFFFF',
    /** Off-white background (page bg) */
    offWhite: '#FAF8F4',
    /** Light gray surface (cards, dividers) */
    grayLight: '#F1EFE8',
    /** Mid gray for muted text */
    grayMid: '#888780',
    /** Semantic success */
    success: '#1D9E75',
    /** Semantic warning */
    warning: '#BA7517',
    /** Semantic danger */
    danger: '#A32D2D',
  },
} as const;

export type BrandColor = keyof typeof BRAND.colors;
